import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TablePagination,
	TableRow,
} from "@mui/material";
import EnhancedTableHead from "./EnhancedTableHead";
import TransactionsTableRow from "./TansactionsTableRow";
import { useTranslation } from "react-i18next";

export default function TransactionsTable({
	order,
	setOrder,
	orderBy,
	setOrderBy,
	visibleRows,
	transactionsLoading,
	page,
	setPage,
	rowsPerPage,
	setRowsPerPage,
	transactionsFiltered,
	wallets,
}) {
	const { t } = useTranslation();

	const handleRequestSort = (event, property) => {
		const isAsc = orderBy === property && order === "asc";
		setOrder(isAsc ? "desc" : "asc");
		setOrderBy(property);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	return (
		<TableContainer
			sx={{
				width: "auto",
				display: "flex",
				mx: 2,
				borderRadius: "10px",
				minWidth: "auto",
			}}
		>
			<Table>
				<EnhancedTableHead
					order={order}
					orderBy={orderBy}
					onRequestSort={handleRequestSort}
					rowCount={visibleRows.length}
				/>
				<TableBody>
					{visibleRows.length === 0 && (
						<TableRow>
							<TableCell>{t("noTransactionsFound")}</TableCell>
						</TableRow>
					)}
					{visibleRows.map((row) => (
						<TransactionsTableRow
							row={row}
							wallets={wallets}
							key={row._id}
						/>
					))}
					<TableRow>
						<TablePagination
							sx={{ border: 0 }}
							rowsPerPageOptions={[10, 20, 40]}
							count={transactionsFiltered.length}
							rowsPerPage={rowsPerPage}
							labelRowsPerPage={t("rowsPerPage")}
							labelDisplayedRows={({ from, to, count }) =>
								`${from}-${to} ${t("of")} ${count !== -1 ? count : `more than ${to}`}`
							}
							page={page}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
						/>
					</TableRow>
				</TableBody>
			</Table>
		</TableContainer>
	);
}
